import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { switchMap, catchError, tap } from 'rxjs/operators';
import {
    ECustomerMissionActions,
    SaveCustomerMission,
    SaveCustomerMissionSuccess,
    UpdateCustomerMission
} from '../actions/customer-mission.actions';
import { Store } from '@ngrx/store';
import { AbstractEffects } from '../../abstract.effects';
import { UpdateSelectedProcedure } from '../actions/selected-procedure.actions';
import { CustomerMissionService } from '../../services/customer-mission.service';
import { GetCustomerProcedures } from '../../../lines/store/actions/customer-procedures.actions';

@Injectable()
export class CustomerMissionEffects extends AbstractEffects {

    constructor(
        private customerMissionService: CustomerMissionService,
        private actions: Actions,
        public override store: Store<any>
    ) {
        super(store);
    }

    procedureCode: string;
    procedureType: string;
    payload: any;

    saveCustomerMission = createEffect(() => this.actions.pipe(
        ofType<SaveCustomerMission>(ECustomerMissionActions.SaveCustomerMission),
        tap(params => {
                this.payload = params.payload;
                this.procedureType = params.procedureType;
                this.procedureCode = params.procedureCode;
            }
        ),
        switchMap((action) => this.customerMissionService.save(action.payload, action.procedureCode)),
        switchMap((response: any) => of(new SaveCustomerMissionSuccess(response))),
        tap( () => {
            this.store.dispatch(new GetCustomerProcedures(this.procedureType, this.payload.externalId));
            this.DisplayMessage(this.procedureCode, 200, new UpdateSelectedProcedure(''), this.payload);
        }),
        catchError((error) => {
            this.DisplayMessage(this.procedureCode, 400);
            return throwError(error);
        })
    ));

    updateCustomerMission = createEffect(() => this.actions.pipe(
        ofType<UpdateCustomerMission>(ECustomerMissionActions.UpdateCustomerMission),
        tap(params => {
                this.payload = params.payload;
                this.procedureType = params.procedureType;
                this.procedureCode = params.procedureCode;
            }
        ),
        switchMap((action) => this.customerMissionService.update(action.payload, action.procedureCode)),
        switchMap((response: any) => of(new SaveCustomerMissionSuccess(response))),
        tap( () => {
            this.store.dispatch(new GetCustomerProcedures(this.procedureType, this.payload.externalId));
            this.DisplayMessage(this.procedureCode, 200, new UpdateSelectedProcedure(''), this.payload);
        }),
        catchError((error) => {
            this.DisplayMessage('error_with_retry', 400);
            return throwError(error);
        })
    ));
}
